import { render, staticRenderFns } from "./customer-task-imports.vue?vue&type=template&id=d7837dee&"
import script from "./customer-task-imports.vue?vue&type=script&lang=js&"
export * from "./customer-task-imports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports